<template>
  <a-card :bordered="false">
      <a-row type="flex" :gutter="[24,24]">
        <!-- <a-col :span="5">
          <a-input placeholder="作品名" v-model="queryParam.workName"></a-input>
        </a-col> -->
        <a-col>
          <a-input
            style="width: 150px"
            placeholder="学生名"
            v-model="queryParam.realname"
          ></a-input>
        </a-col>
        <!-- <a-col :span="5">
          <j-dict-select-tag
            style="width: 120px"
            placeholder="代码类型"
            v-model="queryParam.codeType"
            dictCode="code_type"
          />
        </a-col> -->
        <a-col>
          <!-- <a-select style="width: 120px" v-model="queryParam.type" @change="search">
            <a-select-option key="all" :value="undefined">全部</a-select-option>
            <a-select-option key="false" value="unsub">未提交</a-select-option>
            <a-select-option key="true" value="redo">重做</a-select-option>
          </a-select> -->
          <a-radio-group v-model="queryParam.type" @change="search" button-style="solid">
            <a-radio-button :value="undefined">全部</a-radio-button>
            <a-radio-button value="unsub">未提交</a-radio-button>
            <a-radio-button value="redo">重做</a-radio-button>
          </a-radio-group>
        </a-col>
        <a-col>
          <a-button type="primary" @click="search">查询</a-button>
        </a-col>
      </a-row>
      <a-divider/>
      <a-table
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange"
      >
      </a-table>
  </a-card>
</template>

<script>
import JDictSelectTag from "@/components/dict/JDictSelectTag";
import { JeecgListMixin } from "@/mixins/JeecgListMixin";
import { getAction } from "@/api/manage";

export default {
  name: "TeacherUnsubmitedStudent",
  mixins: [JeecgListMixin],
  components: {
    JDictSelectTag,
  },
  props: {
    isInner: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      columns: [
        {
          title: "学生账号",
          align: "center",
          dataIndex: "username",
          width: 120,
          sorter: true,
        },
        {
          title: "学生姓名",
          align: "center",
          dataIndex: "realname",
          width: 120,
          sorter: true,
        },
        {
          title: "作业名",
          align: "center",
          dataIndex: "mediaName",
          width: 120,
        },
        {
          title: "状态",
          align: "center",
          width: 100,
          dataIndex: "isRedo",
          customRender(v){
            if(v){
              return "重做"
            }else{
              return "未提交"
            }
          }
        },
        // {
        //   title: "布置时间",
        //   align: "center",
        //   width: 150,
        //   dataIndex: "workOpenTime",
        //   sorter: true,
        //   customRender(v, r) {
        //     return r.workOpenTime || r.workCaseOpenTime || '--';
        //   },
        // },
      ],
      ipagination:{
        current: 1,
        pageSize: 999,
        pageSizeOptions: ['999'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      url: {
        list: "/teaching/teachingWork/unsubmittedStudent",
      },
      disableMixinCreated: true, //禁用mixin的created方法
      unitInfo: {},
      queryParam:{
        type: undefined
      }
    };
  },
  created() {
    // if(this.isInner){
    //   this.columns.splice(2,3)
    // }
    if (this.$route.query.departId) {
      this.queryParam.departId = this.$route.query.departId;
    }
    if (this.$route.query.unitId) {
      this.queryParam.unitId = this.$route.query.unitId;
    }
    this.queryParam.type = ""
    this.search();
  },
  methods: {
    search() {
      this.loading = true;
      this.loadData(1);
    },
  },
};
</script>

<style lang="less" scoped>
</style>